/**
 * The practice a patient-file record is saved under: the patient's own practice, not the one
 * selected in the header. A doctor in several practices can have one selected while working in a
 * patient from another, and the server files the record under the group on the patient row.
 * Falls back to the selected practice only when there is no saved patient yet (a new patient).
 */
export function patientGroupId(
  patient: { groupId?: string | null } | null | undefined,
  selectedGroupId: string | null | undefined,
): string | null {
  return patient?.groupId || selectedGroupId || null;
}
